import styles from '../onboarding.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import {
	registerUsingActivationCode,
	updateProfile,
} from '../../../features/authSlice'
import { toastHelper } from '../../../util/toastHelper'
import Slider from '@mui/material/Slider'
import ButtonCustom from '../../atoms/button/ButtonCustom'

const MIN = 100
const MAX = 500000

export const VendorPriceRange = ({ userDetails, setUserDetails, role, setStep }) => {
	const dispatch = useDispatch()

	const email = useSelector((state) => state.auth.user.email)

	const handleChange = (e, newValue) => {
		setUserDetails({
			...userDetails,
			lowerPriceRange: newValue[0],
			upperPriceRange: newValue[1],
		})
	}

	const handleNext = async () => {
		if (userDetails.lowerPriceRange >= userDetails.upperPriceRange) {
			return toastHelper('Invalid range', 'error')
		}
		if (userDetails.type === 'vendor') {
			if (userDetails.hasActivationCode) {
				try {
					// If Wedding Join Code exists, add them to wedding
					const res = await dispatch(
						registerUsingActivationCode({
							verificationCode: userDetails.activationCode.trim(),
							email,
                            role
						})
					).unwrap()

					if (!res || !res.success) return
				} catch (err) {
					console.log(err)
					return
				}
			}
			dispatch(updateProfile({ ...userDetails, role: 'vendor' }))
		} else {
			setStep((step) => step + 1)
		}
	}

	const handleChangeUpperLower = (e) => {
		const value = parseInt(e.target.value)
		if (value >= MIN && value <= MAX) {
			setUserDetails({ ...userDetails, lowerPriceRange: value })
		}
	}

	const handleChangeUpperBound = (e) => {
		const value = parseInt(e.target.value)
		if (value >= MIN && value <= MAX) {
			setUserDetails({ ...userDetails, upperPriceRange: value })
		}
	}

	return (
		<div className={styles.form}>
			<h1>Price Range</h1>
			<p>
				Enter your count below <br /> Don't worry, it doesn't have to be
				the <i>exact</i> number
			</p>

			<div className={styles.priceRange}>
				<input
					style={{ maxWidth: '100px' }}
					onChange={handleChangeUpperLower}
					value={userDetails.lowerPriceRange}
				/>
				-
				<input
					style={{ maxWidth: '100px' }}
					onChange={handleChangeUpperBound}
					value={userDetails.upperPriceRange}
				/>
			</div>
			<Slider
				value={[
					userDetails.lowerPriceRange,
					userDetails.upperPriceRange,
				]}
				onChange={handleChange}
				valueLabelDisplay="auto"
				max={MAX}
				min={MIN}
				sx={{
					color: '#7ca6bd',
					'& .MuiSlider-track': { backgroundColor: '#7ca6bd' },
					'& .MuiSlider-thumb': {
						border: '0.1px solid white',
						width: '12px',
						height: '12px',
					},
					'& .MuiSlider-rail': {
						backgroundColor: '#FFFFFF',
						opacity: 1,
					},
				}}
			/>
			<div className={styles.skipBtn}>
				<button
					data-cy="backbutton"
					onClick={() => {
						setStep((step) => step - 1)
					}}
					className="backButton"
				>
					Back
				</button>
				<ButtonCustom onClick={handleNext} data-cy="nextButton">
					{userDetails.type === 'vendor' ? 'Finish' : 'Next'}
				</ButtonCustom>
			</div>
		</div>
	)
}
